/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [资金返回列表↗](http://yapi.yishou.com/project/128/interface/api/33491) 的 **请求配置**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/RefundBill/detail`
 */
const detailRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/baob/RefundBill/detail",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["srb_id"],
        properties: { srb_id: { type: "string", description: "资金流水id" } },
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            srb_id: { type: "string", description: "资金流水id" },
            title: { type: "string", description: "标题" },
            type: { type: "string", description: "类型" },
            refund_amt: { type: "string", description: "返佣比例" },
            total: { type: "string" },
            refund_amt_rate: { type: "string", description: "返佣比例" },
            refund_service_rate: { type: "string", description: "退换比例" },
            section: { type: "string", description: "描述" },
            remark: { type: "string", description: "备注" },
            explain: {
                type: "object",
                properties: {
                    text: { type: "string" },
                    table: {
                        type: "object",
                        properties: {
                            tr: { type: "array", items: { type: "string" } },
                            td: { type: "array", items: { type: "array", items: { type: "string" } } },
                        },
                    },
                },
            },
            commission: { type: "string", description: "返佣资金" },
            refund_service_charge: { type: "string", description: "返佣金额" },
            pay_time: { type: "string", description: "支付时间" },
            cycle: { type: "string" },
            prenew_goodsno_rate: { type: "string", description: "提前上新比例" },
            allot_24h_rate: { type: "string", description: "24小时配" },
            allot_240h_rate: { type: "string", description: "最终配" },
            month: { type: "string" },
            summary: {
                type: "object",
                properties: {
                    tr: {
                        type: "array",
                        items: { type: "string", tag: "爆版4.23.0" },
                        description: "汇总表头",
                        tag: "爆版4.23.0",
                    },
                    td: { type: "array", items: { type: "string" }, description: "汇总内容", tag: "爆版4.23.0" },
                },
                description: "汇总表",
                tag: "爆版4.23.0",
            },
        },
    },
    requestFunctionName: "detail",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [资金返回列表↗](http://yapi.yishou.com/project/128/interface/api/33491) 的 **请求函数**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `爆版4.23.0`
 * @请求头 `POST /baob/RefundBill/detail`
 */
export const detail = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(detailRequestConfig, requestData), ...args);
};
detail.requestConfig = detailRequestConfig;
/**
 * 接口 [erp返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/33492) 的 **请求配置**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `爆版4.23.0`, `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/index`
 */
const indexRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/RefundBill/index",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        srb_id: { type: "string" },
                        title: { type: "string" },
                        type: { type: "string" },
                        supply_refund_bill_type: { type: "string" },
                        supply_refund_bill_status: { type: "string" },
                        refund_amt: { type: "string" },
                        refund_amt_rate: { type: "string" },
                        refund_service_rate: { type: "string" },
                        remark: { type: "string" },
                        total: { type: "string" },
                        pay_time: { type: "string" },
                        create_time: { type: ["null", "string"] },
                        status: { type: "string" },
                        supply_name: { type: "string" },
                        commission: { type: "string", tag: "爆版4.23.0", description: "上月已扣资金" },
                        prenew_goodsno_rate: { type: "string", tag: "爆版4.23.0", description: "提前上新比例" },
                        allot_24h_rate: { type: "string", tag: "爆版4.23.0", description: "24配率" },
                        allot_240h_rate: { type: "string", tag: "爆版4.23.0", description: "最终配" },
                        supply_id: { type: "string", description: "供应商id", tag: "履约达标返佣发送短信" },
                        level: { type: "string", description: "档位", tag: "履约达标返佣发送短信" },
                    },
                    required: [
                        "srb_id",
                        "title",
                        "type",
                        "supply_refund_bill_type",
                        "supply_refund_bill_status",
                        "refund_amt",
                        "refund_amt_rate",
                        "refund_service_rate",
                        "remark",
                        "total",
                        "pay_time",
                        "create_time",
                        "status",
                        "supply_name",
                        "commission",
                        "prenew_goodsno_rate",
                        "allot_24h_rate",
                        "allot_240h_rate",
                        "supply_id",
                        "level",
                    ],
                },
            },
            count: { type: "number" },
            send_msg_time: { type: "string", description: "发送短信时间", tag: "履约达标返佣发送短信" },
        },
    },
    requestFunctionName: "index",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [erp返回资金流水↗](http://yapi.yishou.com/project/128/interface/api/33492) 的 **请求函数**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `爆版4.23.0`, `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/index`
 */
export const index = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(indexRequestConfig, requestData), ...args);
};
index.requestConfig = indexRequestConfig;
/**
 * 接口 [获取需要发送短信供应商↗](http://yapi.yishou.com/project/128/interface/api/34437) 的 **请求配置**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/getNeedSendMsgSupply`
 */
const getNeedSendMsgSupplyRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/RefundBill/getNeedSendMsgSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            month: { type: "number", description: "月份" },
            meet: { type: "number", description: "符合履约供应商数量" },
            dont_meet: { type: "number", description: "不符合履约供应商数量" },
        },
    },
    requestFunctionName: "getNeedSendMsgSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [获取需要发送短信供应商↗](http://yapi.yishou.com/project/128/interface/api/34437) 的 **请求函数**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/getNeedSendMsgSupply`
 */
export const getNeedSendMsgSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(getNeedSendMsgSupplyRequestConfig, requestData), ...args);
};
getNeedSendMsgSupply.requestConfig = getNeedSendMsgSupplyRequestConfig;
/**
 * 接口 [发送短信↗](http://yapi.yishou.com/project/128/interface/api/34438) 的 **请求配置**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/sendMsgSupply`
 */
const sendMsgSupplyRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/RefundBill/sendMsgSupply",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "sendMsgSupply",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [发送短信↗](http://yapi.yishou.com/project/128/interface/api/34438) 的 **请求函数**
 *
 * @分类 [资金返回↗](http://yapi.yishou.com/project/128/interface/api/cat_3143)
 * @标签 `履约达标返佣发送短信`
 * @请求头 `POST /erp/RefundBill/sendMsgSupply`
 */
export const sendMsgSupply = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(sendMsgSupplyRequestConfig, requestData), ...args);
};
sendMsgSupply.requestConfig = sendMsgSupplyRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/refundBill3143.js